<template>
  <div class="mediaDetail">
    <div class="contentParty">
      <div
        class="contentInfo flexBetween"
        v-if="list.length>0"
      >
        <div
          class="caseList"
          v-for="(item,idx) in list"
          :key="idx"
        >
          <img
            :src="item.logo"
            alt=""
          >
          <div class="contentTitle"> 
            <p class="overflowMulityText2">
              {{ item.customerTitle }}
            </p>
          </div>
          <div class="contents ">
            <p class="overflowMulityText3">
              {{ item.customerDesc }}
            </p>
          </div>
          <div
            type="button"
            class="moreBtn"
            @click="toDetail(item.id)"
          >
            READ MORE
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
 import {getCustomerList} from "@/api/api"
    export default {
        name: 'MediaDetail',
        data() {
            return {
                 list:[]
            }
        },
        created(){
           this.getCustomerList();
        },
        methods:{
            toDetail(id){
                this.$router.push({name: 'caseDetail', query: {id: id}});
            },
            getCustomerList(){
               getCustomerList({
                    pageSize: 0,
                    pageIndex: 1,
                    status:1,//启用
                    origin:1,//前台
                    customerType:2
               }).then(res=>{
                    if (res.code != 10000) {
                       this.$message.error(res.msg || 'Failed to query case sharing');
                      return;
                    }
                   this.list=res.datalist||[];
               })
            }
        }
    }
</script>
<style lang="scss" scoped>
   .mediaDetail{
     background: #F5F5F5;
   }
     .contentParty {
    background: url('https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/caseBg.png') no-repeat center top;
    background-size: 100vw 282px;
    min-height: 282px;
    padding-top: 80px;
    padding-bottom: 52px;
    
    .contentInfo{
    margin: 0 192px;
    padding: 22.2px;
    padding-top: 66.6px;
    overflow: hidden;
    align-items:stretch;
    flex-wrap: wrap;
    .caseList{
     background: #fff;
     padding: 20.6px;
     width: 455px;
     margin-bottom: 17px;
    img{
        width:416px;
        height: 276px;
    }
    .contentTitle{
        font-size: 20px;
        color: #333333;
        line-height: 34px;
        font-weight: bold;
        min-height:74px;
    }
    .contents{
        font-size: 13.3px;
        color: #333333;
        margin-top: 15px;
        text-align: justify;
        min-height:52px;
     }
       
    }
    .moreBtn{
        margin-top: 17px;
        background: #217DF6;
        font-size: 13.3px;
        color: #fff;
        border-radius: 6.66px;
        text-align: center;
        width: 104px;
        height: 17px;
        line-height: 17px;
        cursor: pointer;
        transition-delay: 0.1s;
        &:hover{
             background: #F5F5F5;
             color: #333333;
             transition-delay:0.1s;
        }
      }
    }
    }
</style>
